import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru';
import en from './en';

function initialLanguage(): 'ru' | 'en' {
  try {
    const saved = localStorage.getItem('vatman.lang');
    if (saved === 'ru' || saved === 'en') return saved;
  } catch {
    // Storage unavailable: use the browser language.
  }
  return navigator.language.toLowerCase().startsWith('ru') ? 'ru' : navigator.language.toLowerCase().startsWith('en') ? 'en' : 'ru';
}

void i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru }, en: { translation: en } },
  lng: initialLanguage(),
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  returnObjects: true,
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  try {
    localStorage.setItem('vatman.lang', lng);
  } catch {
    // Not critical.
  }
});
document.documentElement.lang = i18n.language;

export function errorText(code: string): string {
  const key = `errors.${code}`;
  return i18n.exists(key) ? i18n.t(key) : i18n.t('errors.internal');
}

export default i18n;
